<template>
    <div class="toolbox-calendar">
        <div class="pager">
            <div>
                <action icon="prev" @click.native="prevMonth" color="transparent" />
            </div>
            <span @click="init">{{ headline }}</span>
            <div>
                <action icon="next" @click.native="nextMonth" color="transparent" />
            </div>
        </div>
        <table>
            <tr>
                <th>{{ $t('layout.calendar.mon') }}</th>
                <th>{{ $t('layout.calendar.tue') }}</th>
                <th>{{ $t('layout.calendar.wed') }}</th>
                <th>{{ $t('layout.calendar.thu') }}</th>
                <th>{{ $t('layout.calendar.fri') }}</th>
                <th>{{ $t('layout.calendar.sat') }}</th>
                <th>{{ $t('layout.calendar.sun') }}</th>
            </tr>
            <tr v-for="(days, week) in calendar">
                <td v-for="day in days" :class="getClasses(day)" @click="chooseDate(day)">{{ day.day }}</td>
            </tr>
        </table>

        <div class="footer">
        {{ $t('layout.calendar.roster.headline') }} {{ releaseDate }}
        </div>
    </div>
</template>

<script>
import events from '../../events/events';
import shared from '../../pages/planning/shared';

export default
{
    name: 'Calendar',

    props: ['payload'],

    data() {
        return {
            month: null,
            year: null,
            headline: '',
            today: null,
            releaseDate: null,
            calendar: {},
            shared: shared.state,
        }
    },

    computed:
    {
        releasedUntil()
        {
            return shared.getLocation(this.shared.location).releasedUntil;
        },
    },

    created()
    {
        this.init();

        this.headline = this.$t('text.loading');
    },

    methods:
    {
        init()
        {
            this.today = moment().format('YYYY-MM-DD');

            let released = moment(this.releasedUntil);

            this.releaseDate = released.format('DD-MM-YYYY');
            this.month = released.format('MM') * 1;
            this.year = released.format('YYYY');

            this.fetchCalendar();
        },

        fetchCalendar()
        {
            this.$http.get('/api/calendar/' + this.month + '/' + this.year)
            .then(response =>
            {
                this.headline = response.data.headline;
                this.calendar = response.data.calendar;
            });
        },

        chooseDate(day)
        {
            if (this.isChooseable(day))
            {
                let type = (day.date <= this.releasedUntil) ? 'revoke' : 'release';

                if (typeof this.payload.callback == 'function') this.payload.callback(type, day.date, day.localized);
            }
        },

        prevMonth()
        {
            this.month = this.month - 1;

            if (this.month == 0)
            {
                this.month = 12;
                this.year = parseInt(this.year) - 1;
            }

            this.fetchCalendar();
        },

        nextMonth()
        {
            this.month = this.month + 1;

            if (this.month == 13)
            {
                this.month = 1;
                this.year = parseInt(this.year) + 1;
            }

            this.fetchCalendar();
        },

        getClasses(day)
        {
            let classes = [];

            if (day.date <= this.releasedUntil)
            {
                classes.push('is-released');

                if (day.date == this.releasedUntil)
                {
                    classes.push('is-release-date');
                }
                else if (day.date >= this.today)
                {
                    classes.push('is-revokable');
                }
            }

            if (day.date < this.today)
            {
                classes.push('is-inactive');
            }

            if (day.off) classes.push('is-off');

            return classes;
        },

        isChooseable(day)
        {
            // release date is not chooseable
            if (day.date == this.releasedUntil) return false;

            // cannot release roster to the past
            if (day.date < this.today) return false;

            return true;
        },

        close()
        {
            events.$emit('toolbox.close');
        }
    },
}
</script>



// WEBPACK FOOTER //
// Calendar.vue?cfd37d4e